module.exports = __webpack_public_path__ + "static/media/email_example.c97825f7.jpg";